<script setup lang="ts">
import { Icon } from "@/components/ui"
import { useTranslation } from "@/composables"

interface FreemiumBadgeProps {
  variant?: "icon" | "text" | "icon-text"
}

withDefaults(defineProps<FreemiumBadgeProps>(), {
  variant: "icon-text",
})

const { t } = useTranslation()
</script>

<template>
  <span
    class="bg-premium shrink-0 flex items-center gap-1.5 font-comfortaa font-bold text-xs tracking-wide rounded-full text-white"
    :class="variant === 'icon' ? 'p-1' : 'px-2 py-1'"
    data-test="premium-badge"
  >
    <Icon
      v-if="variant === 'icon' || variant === 'icon-text'"
      icon="Crown"
      size="xs"
      class="text-white"
    />
    <div v-if="variant === 'text' || variant === 'icon-text'">
      {{ t("freemium_badge.premium") }}
    </div>
  </span>
</template>
